export const AGE_VERIFIED_FLAG = 'hub2_age_verified_flag';
